import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { LoggerService } from '../logger-service/logger.service';

interface CacheContent {
  expire: number;
  value: any;
}

interface CacheProps {
  key: string;
  value: any;
  ttl?: number;
}


@Injectable({
  providedIn: 'root'
})
export class CacheService {
  constructor(private readonly logger: LoggerService) { }

  getDataInCache(key: string): Observable<any> | undefined {
    const cache = sessionStorage.getItem(key);
    if (!cache) return undefined;

    const data = JSON.parse(cache) as CacheContent;
    const now = new Date().getTime();
    if (now > data.expire) {
      sessionStorage.removeItem(key);
      return undefined;
    }

    this.logger.info(`Elemento encontrado en cache (Session Storage): ${key}`);
    return of(data.value);
  }

  setDataInCache(props: CacheProps): Observable<any> {
    const { key, value, ttl = 300000 } = props
    const expiry = new Date().getTime() + ttl;
    // Seteamos la variable en el Local Storage
    sessionStorage.setItem(key, JSON.stringify({ expire: expiry, value }))
    this.logger.info(`Almacenando en cache (Session Storage) con la llave: ${key}`);
    return of(value);
  }

  cacheObservable(key: string, fallback: Observable<any>, ttl?: number): Observable<any> {
    const cached = this.getDataInCache(key);
    console.log(cached)
    if (cached) return cached;

    return fallback.pipe(
      tap(value => {
        const props = { key, value, ttl }
        this.setDataInCache(props);
      })
    );
  }

}
